export default {
  'settings.title': 'సెట్టింగ్‌లు',
  'settings.subtitle': 'మీ సంస్థ, ఆపరేషన్‌లు, ప్రజలు మరియు ఖాతాను నిర్వహించండి.',
  'settings.subtitleLong': 'మీ సంస్థ, ఆపరేషన్‌లు, ప్రజలు మరియు ఖాతాను నిర్వహించండి — అన్నీ ఒకే చోట.',
  'settings.workspace': 'వర్క్‌స్పేస్',
  'settings.groupOrganization': 'సంస్థ',
  'settings.groupOperations': 'ఆపరేషన్‌లు',
  'settings.groupPeople': 'ప్రజలు',
  'settings.groupAccount': 'ఖాతా',
  'settings.company': 'కంపెనీ',
  'settings.companyDesc': 'ప్రతి రిపోర్ట్ & PDFలో బ్రాండింగ్',
  'settings.ledgers': 'లెడ్జర్‌లు',
  'settings.ledgersDesc': 'శాఖకు ఒక పుస్తకం',
  'settings.line': 'సర్వీస్ లైన్‌లు',
  'settings.lineDesc': 'మీరు పని చేసే ప్రదేశాలు',
  'settings.banks': 'బ్యాంక్‌లు',
  'settings.banksDesc': 'ఆన్‌లైన్ చెల్లింపులు & ఆడిట్ కోసం కంపెనీ బ్యాంక్ ఖాతాలు',
  'settings.finance': 'ఫైనాన్స్ డిఫాల్ట్‌లు',
  'settings.financeDesc': 'ఫైనాన్స్ కోసం వడ్డీ % & OP వడ్డీ',
  'settings.financialYear': 'ఆర్థిక సంవత్సరం',
  'settings.financialYearDesc': 'నివేదికలు & డాష్‌బోర్డ్‌ల సంవత్సరం',
  'settings.sms': 'SMS రిమైండర్‌లు',
  'settings.smsDesc': 'చెల్లింపు రిమైండర్ రోజులు & SMS వినియోగం',
  'settings.payment': 'చెల్లింపులు',
  'settings.paymentDesc': 'సెటిల్‌మెంట్ ప్రాధాన్యతలు',
  'settings.owners': 'యజమానులు',
  'settings.ownersDesc': 'క్యాప్ టేబుల్ మరియు పరిచయాలు',
  'settings.admins': 'వర్క్‌స్పేస్ అడ్మిన్‌లు',
  'settings.adminsDesc': 'డెస్క్ పాత్రలు మరియు జవాబుదారీ',
  'settings.subscription': 'సబ్‌స్క్రిప్షన్',
  'settings.subscriptionDesc': 'ప్లాన్, బిల్లింగ్ & రిన్యూవల్',
  'settings.profile': 'ప్రొఫైల్',
  'settings.profileDesc': 'గుర్తింపు మరియు సైన్-ఇన్ భద్రత',
  'settings.language': 'భాష',
  'settings.languageDesc': 'వెబ్‌సైట్ ప్రదర్శన భాష',
  'settings.languageTitle': 'ప్రదర్శన భాష',
  'settings.languageHint': 'వర్క్‌స్పేస్ అంతటా మెనూలు, లేబుల్‌లు మరియు బటన్‌లు ఎలా కనిపించాలో ఎంచుకోండి.',
  'settings.languageSaved': 'ఈ పరికరం కోసం భాష నవీకరించబడింది.',

  'settings.font': 'ఫాంట్ పరిమాణం',
  'settings.fontDesc': 'ఫోన్ మరియు డెస్క్‌టాప్‌లో టెక్స్ట్ పరిమాణం',
  'settings.fontTitle': 'ప్రదర్శన ఫాంట్ పరిమాణం',
  'settings.fontHint': 'మెనూలు, లేబుల్‌లు మరియు మొత్తాలు ఎంత పెద్దగా కనిపించాలో ఎంచుకోండి. హిందీ మరియు తెలుగులో మొబైల్‌లో చదవడం సులభం కోసం అదనపు పెంపు ఉంటుంది.',
  'settings.fontSaved': 'ఈ పరికరం కోసం ఫాంట్ పరిమాణం నవీకరించబడింది.',
  'settings.fontPreviewLine': 'నమూనా టెక్స్ట్ — మెనూలు, లేబుల్‌లు మరియు EMI మొత్తాలు కలిసి మారుతాయి.',
  'font.compact': 'కాంపాక్ట్',
  'font.comfortable': 'సౌకర్యవంతం',
  'font.large': 'పెద్దది',
  'font.extraLarge': 'అతి పెద్దది',
  'font.maximum': 'గరిష్టం',

  'settings.theme': 'రంగు థీమ్',
  'settings.themeDesc': 'వర్క్‌స్పేస్ అక్సెంట్ రంగు',
  'settings.themeTitle': 'వర్క్‌స్పేస్ రంగు థీమ్',
  'settings.themeHint': 'అక్సెంట్ రంగును ఎంచుకోండి — బటన్‌లు, నావిగేషన్, హైలైట్‌లు మరియు చార్ట్‌లు మొత్తం వెబ్‌సైట్‌లో మారుతాయి.',
  'settings.themeSaved': 'ఈ పరికరం కోసం రంగు థీమ్ నవీకరించబడింది.',
  'settings.themePreview': 'లైవ్ ప్రివ్యూ',
  'settings.themeActiveBadge': 'యాక్టివ్',
  'theme.emerald': 'ఎమరాల్డ్',
  'theme.blue': 'నీలం',
  'theme.violet': 'వైలెట్',
  'theme.rose': 'రోజ్',
  'theme.amber': 'ఆంబర్',
  'theme.indigo': 'ఇండిగో',
  'theme.teal': 'టీల్',
  'theme.orange': 'ఆరెంజ్',

  'settings.fontFineTune': 'స్లైడర్‌తో సూక్ష్మ సర్దుబాటు',
  'settings.fontCurrent': 'ప్రస్తుతం: {{percent}}',
  'settings.fontLivePreview': 'లైవ్ ప్రివ్యూ',
  'settings.fontReset': 'డిఫాల్ట్‌కు రీసెట్',
  'settings.fontSavedAt': '{{percent}} వద్ద సేవ్ చేయబడింది',

  'settingsForm.companyIdentity': 'కంపెనీ గుర్తింపు',
  'settingsForm.legalName': 'చట్టపరమైన కంపెనీ పేరు',
  'settingsForm.displayName': 'ప్రదర్శన / వ్యాపార పేరు',
  'settingsForm.tagline': 'ట్యాగ్‌లైన్',
  'settingsForm.logo': 'లోగో URL',
  'settingsForm.contact': 'సంప్రదించండి',
  'settingsForm.phone': 'ప్రధాన ఫోన్',
  'settingsForm.altPhone': 'ప్రత్యామ్నాయ ఫోన్',
  'settingsForm.email': 'ఇమెయిల్',
  'settingsForm.website': 'వెబ్‌సైట్',
  'settingsForm.addressLine1': 'చిరునామా లైన్ 1',
  'settingsForm.addressLine2': 'చిరునామా లైన్ 2 (ఐచ్ఛికం)',
  'settingsForm.city': 'నగరం',
  'settingsForm.state': 'రాష్ట్రం',
  'settingsForm.pincode': 'పిన్‌కోడ్',
  'settingsForm.country': 'దేశం',
  'settingsForm.registration': 'నమోదు',
  'settingsForm.gstin': 'GSTIN',
  'settingsForm.pan': 'PAN',
  'settingsForm.partners': 'భాగస్వాములు / డైరెక్టర్లు',
  'settingsForm.saveCompany': 'కంపెనీ ప్రొఫైల్ సేవ్ చేయండి',
  'settingsForm.ledgerTitle': 'శాఖకు ఒక పుస్తకం',
  'settingsForm.ledgerHint': 'ప్రతి లెడ్జర్‌కు దాని స్వంత డెస్క్ లాగిన్ మరియు ప్రత్యేక రికార్డులు లభిస్తాయి.',
  'settingsForm.ledgerName': 'లెడ్జర్ పేరు',
  'settingsForm.deskLogin': 'డెస్క్ లాగిన్ ఇమెయిల్',
  'settingsForm.createLedger': 'లెడ్జర్ సృష్టించండి',
  'settingsForm.serviceLines': 'సర్వీస్ లైన్‌లు',
  'settingsForm.addLine': 'లైన్ జోడించండి',
  'settingsForm.banksList': 'కంపెనీ బ్యాంక్ ఖాతాలు',
  'settingsForm.addBank': 'బ్యాంక్ ఖాతా జోడించండి',
  'settingsForm.bankName': 'బ్యాంక్ పేరు',
  'settingsForm.accountName': 'ఖాతా పేరు',
  'settingsForm.accountNumber': 'ఖాతా నంబర్',
  'settingsForm.branch': 'శాఖ',
  'settingsForm.ifsc': 'IFSC',
  'settingsForm.confirmDeleteBank': 'ఈ బ్యాంక్ ఖాతాను తొలగించాలా?',
  'settingsForm.noBanksYet': 'ఇంకా బ్యాంక్ ఖాతాలు లేవు. ఆన్‌లైన్ ట్రాకింగ్ కోసం ఒకటి జోడించండి.',
  'settingsForm.defaultInterest': 'డిఫాల్ట్ వడ్డీ %',
  'settingsForm.opInterest': 'OP వడ్డీ %',
  'settingsForm.overduePenalty': 'ఆలస్య పెనాల్టీ',
  'settingsForm.reminderDays': 'చెల్లింపు ముందు రిమైండర్ రోజులు',
  'settingsForm.saveReminders': 'రిమైండర్ సెట్టింగ్‌లు సేవ్ చేయండి',
  'settingsForm.subscriptionPlan': 'ప్రస్తుత ప్లాన్',
  'settingsForm.changePassword': 'పాస్‌వర్డ్ మార్చండి',
  'settingsForm.currentPassword': 'ప్రస్తుత పాస్‌వర్డ్',
  'settingsForm.newPassword': 'కొత్త పాస్‌వర్డ్',
  'settingsForm.confirmPassword': 'పాస్‌వర్డ్ నిర్ధారించండి',
  'settingsForm.addAdmin': 'అడ్మిన్ జోడించండి',
  'settingsForm.role': 'పాత్ర',
  'settingsForm.permissions': 'అనుమతులు',
  'settingsForm.addOwner': 'యజమానిని జోడించండి',
  'settingsForm.shareholding': 'షేర్‌హోల్డింగ్ %',
} as const;
